import React, { useEffect, useState } from "react";
import { Switch } from 'antd';
import moment from "moment";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Pagination from '@material-ui/lab/Pagination';
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Collapse, Typography, Box } from '@mui/material';

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import useAuth from "hooks/useAuth";
import CardHeader from "components/Card/CardHeader.js";
import ModalAddCobli from "components/ModalAddCobli/ModalAddCobli";
import ModalDeleteRouting from "components/ModalDeleteRouting/ModalDeleteRouting";
import ModalRemoveNfRouting from "components/ModalRemoveNfRouting/ModalRemoveNfRouting";
import ModalAddNfRouting from "components/ModalAddNfRouting/ModalAddNfRouting";
import Table from "components/Table/Table.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";

import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api.js";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";

const styles = {
    colorCard: {
        color: "#999"
    },
    colorCardWeight: {
        color: "#000",
        fontSize: "20px",
        fontWeight: "bold"
    },
    dropDown: {
        width: "80%"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0",
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF",
        },
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1",
        },
    },
    colorCard: {
        color: "#000",
        marginBottom: "-1em",
        fontSize: "14px",
        textAlign: "center"
    },
    floatRight: {
        float: "right",
    },
    maxwidht: {
        maxWidth: "107%",
    },
    toogleclass: {
        marginTop: "15px",
        marginBottom: "15px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50",
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)",
    },
    zindex: {
        zIndex: "0 !important",
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px",
        display: "flex",
        justifyContent: "center"
    },

    sizeAmount: {
        fontSize: "20px",
    },
    marginFor: {
        minHeight: "8em",
        marginTop: "-10px"
    },
    fontSizeOf: {
        fontSize: "10px",
    },
    marg: {
        float: "left",
    },
    List: {
        border: "1px solid #d9dddd",
    },
    mgTop: {
        marginTop: "12px",
        float: "left",
        position: "relative",
        marginLeft: "3px",
    },
    tp: {
        marginTop: "10px",
    },
    center: {
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
    },
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
export default function Cobli() {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    const { storageId } = useAuth();
    const classes = useStyles();
    const classes2 = useStyles2();

    const index = { id: 1 };

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [table, setTable] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(10);
    const [id_car, setId_car] = useState(0);
    const [cars, setCars] = useState([]);
    const [idDelete, setIdDelete] = useState(null);
    const [removeData, setRemoveData] = useState(null);
    const [idRouting, setIdRouting] = useState(null);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [modalAddCobli, setModalAddCobli] = useState(false)
    const [modalShowRemoveNf, setModalShowRemoveNf] = useState(false);
    const [modalShowAddNf, setModalShowAddNf] = useState(false);
    const [importModal, setImportModal] = useState(false);
    const [expanded, setExpanded] = useState({});

    const handleToggle = (index) => {
        setExpanded((prevExpanded) => ({
            ...prevExpanded,
            [index]: !prevExpanded[index],
        }));
    };
    useEffect(() => {
        getAllCar();
        // getAllRoutings();
        getAllRoutingToCar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        getAllRoutingToCar();
    }, [page, startDate, endDate, id_car]);
    const loadModal = async () => {
        setImportModal(true);
    };
    const abrirModal = () => {
        if (!modalAddCobli) {
            loadModal();
        };
        setModalAddCobli(true);
    };
    const openModalDelete = (route) => {
        if (!modalShowDelete) {
            loadModal();
        };
        setModalShowDelete(true);
        setIdDelete(route);
    };
    const openModalRemoveNf = (id, nf) => {
        if (!modalShowRemoveNf) {
            loadModal();
        };
        setRemoveData({ id, nf });
        setModalShowRemoveNf(true);
    };
    const openModalAddNf = (id) => {
        if (!modalShowAddNf) {
            loadModal();
        };
        setIdRouting(id)
        setModalShowAddNf(true);
    };
    const getAllCar = async () => {
        const data = await api.get(`/car?id=${storageId}&perPage=1000&page=1`);

        let car_admmin = [{ id: 0, model: "TODOS", deliverymanname: "" }];
        for (let i = 0; i < data.data.car.length; i++) {
            car_admmin = [...car_admmin, data.data.car[i]];
        }
        setCars(car_admmin);
    };

    const getAllRoutingToCar = async () => {
        try {
            const data = await api.get(`/routing/cobli/routes?perPage=10&page=${page}`);
            console.log(data);
            if (data.status === 200) {
                setTable(data.data.content);
                setTotalPages(data.data.total_pages)
            };
        } catch (error) {
            console.log(error)
            //return alert(`Nao foi possivel carregar rotas: ${error}`);
        }
    };
    const handleChange = (event, value) => {
        setPage(value);
    };
   
    function getRoutesTable() {
        let teste = [];
        for (let i = 0; i < table.length; i++) {
            teste[i] = [];
            teste[i].push(table[i].name);
            teste[i].push(moment(table[i].created_at).format('DD/MM/YYYY'));
            //teste[i].push(`${table[i].address}`);

        };
        return teste;
    };
    return (
        <><GridContainer>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Nova Rota</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <Button color="success" onClick={() => abrirModal()}>
                            Nova Rota
                        </Button>
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Data Inicio</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <DatePicker
                            className={classes.marginDate}
                            selected={startDate}
                            onChange={(date) => date ? setStartDate(date.withoutTime()) : setStartDate(null)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Digite ou clique aqui"
                            disabledKeyboardNavigation
                            locale={pt} />
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Data Final</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <DatePicker
                            className={classes.marginDate}
                            selected={endDate}
                            onChange={(date) => date ? setEndDate(date.withoutTime()) : setEndDate(null)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Digite ou clique aqui"
                            disabledKeyboardNavigation
                            locale={pt} />
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Filtrar Carros</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <Form.Control onChange={event => setId_car(event.target.value)} value={id_car} as="select" className={classes.dropDown}>
                            {cars.map(car => (
                                <option key={`car_${car.id}`} value={car.id}>{car.model}</option>
                            ))}
                        </Form.Control>
                    </div>
                </Card>
            </GridItem>
        </GridContainer>
            <Box>

                <Card>
                    <CardHeader className={classes.zindex} color={"primary"}>
                        <h4 className={classes.cardTitleWhite}>Rotas Rio Janeiro</h4>
                    </CardHeader>
                    <CardBody>
                        <Table
                            index={index}
                            tableHeaderColor="primary"
                            tableHead={["Região", "Data"]}
                            tableData={getRoutesTable()}
                        />
                    </CardBody>
                </Card>

                <Pagination count={totalPages} page={page} onChange={handleChange} />
                {modalShowDelete && importModal && (
                    <ModalDeleteRouting key={String("del_" + index.id)} props={idDelete} show={modalShowDelete} onHide={() => setModalShowDelete(false)} getAllRouting={getAllRoutingToCar} />
                )}
                {modalShowRemoveNf && importModal && (
                    <ModalRemoveNfRouting key={`remove_nf`} props={removeData} show={modalShowRemoveNf} onHide={() => setModalShowRemoveNf(false)} getAllRouting={getAllRoutingToCar} />
                )}
                {modalShowAddNf && importModal && (
                    <ModalAddNfRouting key={`add_nf`} props={idRouting} show={modalShowAddNf} onHide={() => setModalShowAddNf(false)} getAllRouting={getAllRoutingToCar} />
                )}
                {modalAddCobli && importModal && (
                    <ModalAddCobli
                        key={String("add_" + storageId)}
                        show={modalAddCobli}
                        onHide={() => setModalAddCobli(false)}
                        cars={cars}
                        loadRouting={() => getAllRoutingToCar}
                    />
                )}

            </Box>
        </>
    );
};